import React, { useEffect } from "react";
import { HStack } from "@chakra-ui/react";
import Dropdown from "react-dropdown";
import { useFollowUp } from "providers/FollowUpProvider";

export default function FollowupDropdown(props: {
  FollowUpOptions: any;
  handleChangeId: any;
  selectedFollowupId: any;
  placeHolder: string;
  key?: any;
}) {
  const { setChild, dispatch, followupInfo } = useFollowUp();
  const selectedItem = props.FollowUpOptions.find(item => item.value === followupInfo.id);
  const handleselect = (e: string) => {
    props.handleChangeId(e);
  };
  useEffect(() => {
    handleselect(followupInfo.id);
  }, []);

  return (
    <HStack spacing="5" w="640px" className="followup-dropdown">
      <Dropdown
        options={props.FollowUpOptions}
        onChange={FollowUpOptions => handleselect(FollowUpOptions.value)}
        value={props.selectedFollowupId ? selectedItem : null}
        placeholder={props.placeHolder}
        controlClassName={`custom-control ${props.selectedFollowupId ? "" : "addError"}`}
        arrowClassName="custom-arrow"
        menuClassName="custom-menu"
        placeholderClassName="custom-placeholder"
      />
    </HStack>
  );
}
